import { render, staticRenderFns } from "./MeetingDetail.vue?vue&type=template&id=860d6a66&"
import script from "./MeetingDetail.vue?vue&type=script&lang=ts&"
export * from "./MeetingDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBreadcrumbs,VBtn})
